module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-stone-path.e3394c9e.png";